/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisqualifiedTeamInfo } from './DisqualifiedTeamInfo';
import {
    DisqualifiedTeamInfoFromJSON,
    DisqualifiedTeamInfoFromJSONTyped,
    DisqualifiedTeamInfoToJSON,
    DisqualifiedTeamInfoToJSONTyped,
} from './DisqualifiedTeamInfo';

/**
 * Result of disqualifying a team
 * @export
 * @interface TeamDisqualificationResponse
 */
export interface TeamDisqualificationResponse {
    /**
     * 
     * @type {DisqualifiedTeamInfo}
     * @memberof TeamDisqualificationResponse
     */
    team: DisqualifiedTeamInfo;
    /**
     * 
     * @type {number}
     * @memberof TeamDisqualificationResponse
     */
    matchesForfeited: number;
    /**
     * 
     * @type {boolean}
     * @memberof TeamDisqualificationResponse
     */
    refundIssued: boolean;
    /**
     * 
     * @type {number}
     * @memberof TeamDisqualificationResponse
     */
    refundAmount?: number;
}

/**
 * Check if a given object implements the TeamDisqualificationResponse interface.
 */
export function instanceOfTeamDisqualificationResponse(value: object): value is TeamDisqualificationResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('matchesForfeited' in value) || value['matchesForfeited'] === undefined) return false;
    if (!('refundIssued' in value) || value['refundIssued'] === undefined) return false;
    return true;
}

export function TeamDisqualificationResponseFromJSON(json: any): TeamDisqualificationResponse {
    return TeamDisqualificationResponseFromJSONTyped(json, false);
}

export function TeamDisqualificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamDisqualificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': DisqualifiedTeamInfoFromJSON(json['team']),
        'matchesForfeited': json['matchesForfeited'],
        'refundIssued': json['refundIssued'],
        'refundAmount': json['refundAmount'] == null ? undefined : json['refundAmount'],
    };
}

export function TeamDisqualificationResponseToJSON(json: any): TeamDisqualificationResponse {
    return TeamDisqualificationResponseToJSONTyped(json, false);
}

export function TeamDisqualificationResponseToJSONTyped(value?: TeamDisqualificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': DisqualifiedTeamInfoToJSON(value['team']),
        'matchesForfeited': value['matchesForfeited'],
        'refundIssued': value['refundIssued'],
        'refundAmount': value['refundAmount'],
    };
}

